// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/Assignees/Content/SearchResult/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Board_Content_Main_Board_Board_Content_Card_Assignees_Content_SearchResult($search_term: String!, $parent_company_id: uuid!) {
  vaxiom_persons_search(
    search_term: $search_term
    parent_company_id: $parent_company_id
    whole_parent_company: true
    employee_search: true
  ) {
    person: vaxiom_person {
      id
      _id
      first_name
      middle_name
      last_name
      public_user {
        id
      }
    }
  }
}

`